'use strict';

class SuperProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainImg = this.querySelector('.sph-gallery__main-img');
    this.thumbs = this.querySelectorAll('[data-sph-thumb]');
    this.section = this.closest('.product__item-js');
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.setActive(thumb));
    });
    if (this.section) {
      this.section.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) {
          this.syncVariantMedia();
        }
      });
    }
  }

  setActive(thumb) {
    const src = thumb.dataset.src;
    const srcset = thumb.dataset.srcset;
    if (!this.mainImg || !src) return;
    this.mainImg.src = src;
    if (srcset) {
      this.mainImg.srcset = srcset;
    } else {
      this.mainImg.removeAttribute('srcset');
    }
    this.thumbs.forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }

  syncVariantMedia() {
    if (!this.section) return;
    const jsonEl = this.section.querySelector('variant-radios-detail script[type="application/json"]');
    if (!jsonEl) return;
    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }
    const checked = this.section.querySelectorAll('variant-radios-detail input[type="radio"]:checked');
    const selected = {};
    checked.forEach((input) => {
      selected[input.name] = input.value;
    });
    const match = variants.find((v) => {
      return Object.keys(selected).every((key, i) => v[`option${i + 1}`] === selected[key]);
    });
    if (match && match.featured_image && match.featured_image.src) {
      this.mainImg.src = match.featured_image.src;
      this.mainImg.removeAttribute('srcset');
      this.thumbs.forEach((t) => {
        t.classList.toggle('is-active', t.dataset.src === match.featured_image.src);
      });
    }
  }
}

customElements.define('super-product-gallery', SuperProductGallery);
